// import imagesloaded from 'imagesloaded';

export default {
  init() {

    $('.js-artist-link').click(function (e) {
      e.preventDefault();
      $('.js-artist-link').removeClass('active');
      $(this).addClass('active');
      var targetUrl = $(this).attr('href');

      if ($(this).hasClass('artists__alpha-link')) {
        var targetAlpha = $(this).data('target-alpha');
        $(targetAlpha)[0].scrollIntoView({
          behavior: 'smooth',
        });
        $(targetAlpha).next().addClass('active');
      }

      $.ajax({
        url: targetUrl,
        success: function (data) {
          var $newDiv = $(data).find('.artists__info-inner');
          var $oldDiv = $('.artists__info-inner');
          // window.history.pushState('object or string', 'Title', targetUrl);
          window.history.pushState({ 'pageTitle': data.pageTitle }, '', targetUrl);
          $('.artists__info').prepend($newDiv);
          $('.artists__info').imagesLoaded(function() {
            $oldDiv.fadeOut(300, function () { 
              $(this).remove(); 
            });
          })
          
          // $('.artists__info-inner').animate({ opacity: 1 });
        },
      });
    });

    // $('.artists__list').scroll(function () {
    //   var $scrollbar = $('.scrollbar');
    //   var scroll = $('.artists__list').scrollTop();
    //   var listHeight = $('.artists__list').outerHeight();
    //   var listHeightInner = $('.artists__list')[0].scrollHeight;
    //   var scrollbarHeight = $scrollbar.height();

    //   var scrollPercent = scroll / (listHeightInner - listHeight);
    //   var pageHeight = $('.artists__info').height() - scrollbarHeight;
    //   var scrollPixels = pageHeight * scrollPercent;

    //   // console.log('scrollPixels = ' + scrollPixels);
    //   // console.log('listHeight = ' + listHeight);

    //   $scrollbar.css('transform', 'translateY(' + scrollPixels + 'px)')
    // });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/post-type-archive-artist.js